import Api from '../Api';

export const getFabrics = () => async dispatch => {
  const { data } = await Api.get('/fabrics');
  dispatch({
    type: 'FETCH_FABRICS',
    payload: data,
  });
};

export const clearFabrics = () => {
  return {
    type: 'CLEAR_FABRICS',
  };
};

export const getFabric = id => async dispatch => {
  const { data } = await Api.get(`/fabrics/${id}`);
  dispatch({
    type: 'FETCH_FABRIC',
    payload: data,
  });
};

export const clearFabric = () => {
  return {
    type: 'CLEAR_FABRIC',
  };
};
